
import { computed, defineComponent, PropType, ref, watch } from 'vue'
import { CtProp } from '@/models/interfaces/content-type'
import LabelBox from '@/pages/Products/components/LabelBox.vue'
import TrashIcon from '@/components/Icons/TrashIcon.vue'
import { QSelect } from 'quasar'

export default defineComponent({
  name: 'ProductOptionCard',
  components: { TrashIcon, LabelBox },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    propValues: {
      type: Object as PropType<{ [key: CtProp['sys']['id']]: CtProp['value'][] }>,
      required: true,
    },
    productOption: {
      type: Object as PropType<CtProp>,
      required: true,
    },
    propChoices: {
      type: Array as PropType<Array<{ label: CtProp['name'], value: CtProp['sys']['id'], alreadyUsed: boolean }>>,
      default: () => []
    }
  },
  emits: ['update:product-option'],
  setup (props, { emit }) {
    const qSelect = ref<QSelect | null>(null)
    const qSelectInput = computed(() => qSelect.value?.$el?.querySelector('input'))

    const setInputWidth = (text?: string | null) => {
      if (!qSelectInput.value) return
      const size = Math.max(
        (text ?? '').length,
        1,
      )
      qSelectInput.value.setAttribute('size', size.toString())
    }

    watch(() => [qSelectInput.value], () => {
      if (!qSelectInput.value) return
      if (selectedPropChoice.value) {
        setInputWidth(selectedPropChoice.value.label)
      } else {
        if (qSelectInput.value.getAttribute('size') === '1') return
        qSelectInput.value.setAttribute('size', '1')
      }
    })

    const selectedPropChoice = computed({
      get: () => props.propChoices.find(pc => pc.value === props.productOption.sys.id),
      set: (newChoice) => {
        emit('update:product-option', newChoice)
      }
    })

    const alteredPropChoices = computed(
      () => props.propChoices.filter(pc => !pc.alreadyUsed)
    )

    const filterOptions = ref<{ label: any, value: any }[]>([])

    const selectFilter = (val, update) => {
      update(() => {
        if (val === '') {
          filterOptions.value = alteredPropChoices.value
        } else {
          const needle = val.toLowerCase()
          filterOptions.value = alteredPropChoices.value.filter(
            option => option['label'] && option['label'].toLowerCase().indexOf(needle) > -1
          )
        }
      })
    }

    return {
      setInputWidth,
      selectedPropChoice,
      alteredPropChoices,
      filterOptions,
      selectFilter,
    }
  }
})
